import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import Review from '../../../custom/Review'
import IconReview from '/public/icons/icon-review.svg'
import styles from './styles.module.scss'
import { useState, useEffect } from 'react'
import isEmpty from 'lodash-es/isEmpty'
import LazyImage from '../../../elements/LazyImage'
import { getRandom } from '../../../helpers/getRandom'
import Grid from '../../../elements/Grid'
import Button from '../../../elements/Button'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import { CSSTransition } from 'react-transition-group'
import IconMore from '/public/icons/icon-more.svg'
import { getS3Url } from '../../../helpers/getS3Url'
import { useRouter } from 'next/router'
import moment from 'moment'

const formatDate = (date) => {
  if (!date) return ''
  return moment(date).utc().format('MMMM - YYYY')
}

const Reviews = ({ property, reviews, translations }) => {
  const [images, setImages] = useState([])
  const [number, setNumber] = useState(6)
  const { isTablet } = useResponsive()
  const router = useRouter()

  useEffect(() => {
    if (property.cloudflare_gallery && !isEmpty(property.cloudflare_gallery)) {
      const gallery =
        property.cloudflare_gallery.length < 3
          ? property.cloudflare_gallery
          : getRandom(property.cloudflare_gallery, 3)
      const images = gallery.map((picture) => getS3Url(picture, '960'))
      setImages(images)
    } else {
      property?.pictures && setImages(getRandom(property?.pictures, 3))
    }
  }, [])

  if (isEmpty(reviews)) {
    return
  }

  return (
    <Section separator variant={['white']}>
      <Container variant={['-xs']}>
        <IconReview className={styles.icon} />

        <h2
          dangerouslySetInnerHTML={{
            __html: translations?.title[router.locale]
          }}
        ></h2>

        <div className={styles.separator}></div>

        <div className={styles.reviews}>
          <div className={styles.reviews__row}>
            {reviews?.map(
              (item, index) =>
                index < 3 && (
                  <Review
                    date={formatDate(item.createdAt)}
                    content={item.public_review}
                    name={item.fullName || 'Anonymous'}
                    key={`review-first-row-${index}`}
                    {...item}
                  />
                )
            )}
          </div>
          {images.length > 2 && (
            <div className={styles.reviews__row}>
              {images &&
                images.map((item, index) => (
                  <div
                    className={styles.reviews__image}
                    key={`review-image-row-${index}`}
                  >
                    <LazyImage layout="fill" src={item.original || item} />
                  </div>
                ))}
            </div>
          )}

          {reviews.length > 3 && (
            <>
              <Grid
                className={styles.reviews__grid}
                variant={[isTablet ? 'grid-1' : 'grid-3']}
              >
                {reviews?.map(
                  (item, index) =>
                    index >= 3 &&
                    index < number && (
                      <CSSTransition
                        classNames="opacity"
                        appear={true}
                        key={`review-additional-items-${index}`}
                        in={index <= number}
                        timeout={{ enter: 200, exit: 200 }}
                      >
                        <Review
                          date={formatDate(item.createdAt)}
                          content={item.public_review}
                          name={item.fullName || 'Anonymous'}
                          key={index}
                          {...item}
                        />
                      </CSSTransition>
                    )
                )}
              </Grid>

              {number < reviews.length && (
                <div className={styles.reviews__more}>
                  <Button
                    appendIcon={<IconMore width={21} />}
                    arrow={false}
                    onClick={() => setNumber(number + 3)}
                    variant={['color-accent']}
                  >
                    {translations?.button[router.locale]}
                  </Button>
                </div>
              )}
            </>
          )}
        </div>
      </Container>
    </Section>
  )
}

export default Reviews
